import Cookies from 'js-cookie';

const initChatbot = () => {
  document.querySelectorAll('.js-chatbot').forEach(($el) => {
    const $clone = document.importNode($el.content, true);
    const $chatbotWrapper = document.body.querySelector('.page__content');
    const chatbotCookie = Cookies.get('bawu-chatbot');

    if (chatbotCookie && $chatbotWrapper && $clone) {
      $chatbotWrapper.appendChild($clone);

      document.querySelector('#corey .corey-toggle').addEventListener('click', (event) => {
        event.preventDefault();
        document.getElementById('corey').classList.toggle('corey-show');
      });
    }
  });
};

if (!document.body.classList.contains('kb-preview')) {
  initChatbot();
}

export default initChatbot;
